module.exports = require('./helpers/bundle-url').getBundleURL('9ZeSD') + "logo-dark.eefe0b7f.svg";